import "./application.scss";
import "preline";
import "@hotwired/turbo-rails";
import "../controllers";

// Импорт видео для Vite манифеста
import "../videos/promo.mp4";
import "../videos/promo_vert.mp4";
import "../videos/short_video.mp4";

// Медленный плавный скролл к якорям
function smoothScrollTo(element, duration = 1000) {
  const targetPosition =
    element.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}

let scrollHandlerAttached = false;

function initializePage() {
  // Плавный скролл к якорям
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (href === "#") return;

      e.preventDefault();
      const target = document.querySelector(href);

      if (target) {
        smoothScrollTo(target, 700);
      }
    });
  });

  // Кнопка "наверх"
  const scrollToTopBtn = document.getElementById("scrollToTop");

  if (scrollToTopBtn) {
    // Проверка темы секции
    function updateButtonTheme() {
      const darkSections = document.querySelectorAll('[data-theme="dark"]');
      const buttonRect = scrollToTopBtn.getBoundingClientRect();
      const buttonCenter = buttonRect.top + buttonRect.height / 2;

      let isDarkSection = false;

      darkSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= buttonCenter && rect.bottom >= buttonCenter) {
          isDarkSection = true;
        }
      });

      if (isDarkSection) {
        // Светлая тема для темного фона
        scrollToTopBtn.classList.remove(
          "border-black",
          "hover:bg-black",
          "hover:text-white",
        );
        scrollToTopBtn.classList.add(
          "border-white",
          "hover:bg-white",
          "hover:text-black",
          "text-white",
        );
      } else {
        // Темная тема для светлого фона
        scrollToTopBtn.classList.remove(
          "border-white",
          "hover:bg-white",
          "hover:text-black",
          "text-white",
        );
        scrollToTopBtn.classList.add(
          "border-black",
          "hover:bg-black",
          "hover:text-white",
        );
      }
    }

    // Показ/скрыть кнопку и обновить тему при скролле
    if (!scrollHandlerAttached) {
      window.addEventListener("scroll", () => {
        if (window.pageYOffset > 300) {
          scrollToTopBtn.classList.remove("opacity-0", "pointer-events-none");
          scrollToTopBtn.classList.add("opacity-70");
        } else {
          scrollToTopBtn.classList.add("opacity-0", "pointer-events-none");
          scrollToTopBtn.classList.remove("opacity-70");
        }

        updateButtonTheme();
      });
      scrollHandlerAttached = true;
    }

    // Скролл наверх при клике
    scrollToTopBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    // Начальная проверка темы и видимости
    updateButtonTheme();

    // Проверка видимости кнопки при инициализации
    if (window.pageYOffset > 300) {
      scrollToTopBtn.classList.remove("opacity-0", "pointer-events-none");
      scrollToTopBtn.classList.add("opacity-70");
    } else {
      scrollToTopBtn.classList.add("opacity-0", "pointer-events-none");
      scrollToTopBtn.classList.remove("opacity-70");
    }
  }
}

// Инициализация при загрузке и при Turbo-переходах
document.addEventListener("DOMContentLoaded", initializePage);
document.addEventListener("turbo:load", () => {
  // Переинициализация Preline компонентов
  if (window.HSStaticMethods) {
    window.HSStaticMethods.autoInit();
  }
  // Небольшая задержка для уверенности что DOM готов
  setTimeout(initializePage, 100);
});
document.addEventListener("turbo:render", () => {
  // Переинициализация Preline компонентов
  if (window.HSStaticMethods) {
    window.HSStaticMethods.autoInit();
  }
  initializePage();
});
